import { normalizeLocaleString } from '../../i18n/localeUtils';
import { configuredLanguage, eventBus } from '../../internal';
import { AxiosRequestConfig } from '../Axios';

let formatLocale = configuredLanguage;

// Normally would use the global consts for event name and settings key but those
// are in nova-commons. Have to hard-code them in nova-core instead.
eventBus.subscribe('SettingsEvent.Change', (_eventName, eventData) => {
  if (!eventData || !eventData.data || !eventData.data.data) return;
  for (const entry of eventData?.data?.data) {
    if (entry.key === 'FormatLocale.DefaultLocale') {
      formatLocale = entry.value ?? 'en';
    }
  }
});

export const setAcceptLocaleHeader = (locale: string) => {
  formatLocale = locale;
};

export const addAcceptLocaleHeader = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers = config.headers ?? {};
  config.headers['Accept-Locale'] =
    config.headers['Accept-Locale'] ?? normalizeLocaleString(formatLocale);
  return config;
};
